/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.fintech.outages.rpc.FintechOutagesRpc
 */
import * as References from './FintechOutagesRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: noAuthHttp
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.fintech.outages.rpc.FintechOutagesRpc#getZuoraOutageStatus
 */
export const GET_ZUORA_OUTAGE_STATUS_QUERY_FIELD_NAME = 'com_hubspot_fintech_outages_rpc_FintechOutagesRpc_getZuoraOutageStatus';
export const GET_ZUORA_OUTAGE_STATUS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ZUORA_OUTAGE_STATUS_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getZuoraOutageStatusRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});